import { pdfjs, Document, Page } from "react-pdf";
import { useState } from "react";
import styles from "./BasesStyle";
// Configuración del worker de PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

function MiPDF() {
  const [numPages, setNumPages] = useState(null);
  const [scale, setScale] = useState(1.0);

  const zoomIn = () => setScale((prev) => Math.min(prev + 0.2, 3));
  const zoomOut = () => setScale((prev) => Math.max(prev - 0.2, 0.5));
  const onDocumentLoadSuccess = ({ numPages }) => setNumPages(numPages);

  return (
    <div style={styles.container}>
      <div style={styles.buttonContainer}>
        <button
          style={styles.button}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#004880")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#005A9C")
          }
          onClick={zoomOut}
        >
          - Zoom
        </button>

        <button
          style={{ ...styles.button, ...styles.buttonZoomIn }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#5aa52f")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#6CB33F")
          }
          onClick={zoomIn}
        >
          + Zoom
        </button>
      </div>

      <div style={styles.pageContainer}>
        {/* Aqui se carga el documento */}
        <Document
          file="/Bases FDS Colbún Coronel 2026.pdf"
          onLoadSuccess={onDocumentLoadSuccess}
          renderMode="canvas"
        >
          {numPages &&
            Array.from({ length: numPages }, (_, i) => (
              <Page
                key={`page_${i + 1}`}
                pageNumber={i + 1}
                scale={scale}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            ))}
        </Document>
      </div>
    </div>
  );
}

export default MiPDF;
